import { render } from "./PeakSeasonDecoratorComponent.vue?vue&type=template&id=b1401508&scoped=true"
import script from "./PeakSeasonDecoratorComponent.vue?vue&type=script&lang=js"
export * from "./PeakSeasonDecoratorComponent.vue?vue&type=script&lang=js"

import "./PeakSeasonDecoratorComponent.vue?vue&type=style&index=0&id=b1401508&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1401508"]])

export default __exports__